<dashboard-dialog-frame [icon]='icon()' header='Mark Presentation Status' [actions]='actions' [dialogRef]='dialogRef'>

	<div class="final-presentation-mark-final-presentation-status-dialog">
		<readonly-access [readonly]="isReadonly()"></readonly-access>
		@if(!finalDeckDueUTC()){
		<p class="p-1">This accelerator does not have a Final Presentation Deck Submission Deadline. Please reach out to
			Tech or Program Experience to resolve this.</p>
		}
		@else{
		<table style='width:100%' class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>
			<tr>
				<td style="width: 20%;">Status</td>
				<td>
					<droplist [items]='statuses()' [selectedItem]='selectedItem()' [readonly]="isReadonly()"
						(selectionChange)='onViewDroplistChange($event)'>
					</droplist>
				</td>
			</tr>
		</table>
		<p class="color-darkred p-2">{{errorMessage()}}</p>

		}
	</div>

</dashboard-dialog-frame>